import { render, staticRenderFns } from "./brand-ex-module.vue?vue&type=template&id=3a08436c&scoped=true"
import script from "./brand-ex-module.vue?vue&type=script&lang=js"
export * from "./brand-ex-module.vue?vue&type=script&lang=js"
import style0 from "./brand-ex-module.vue?vue&type=style&index=0&id=3a08436c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08436c",
  null
  
)

export default component.exports